// PKCE for the QR login: the pc makes a verifier that never leaves it, and sends Laravel only
// its challenge. The code in the QR on screen is public (anyone can photograph it); collecting
// the token at POST /api/auth/qr/claim needs the verifier too (HavunCore plan
// .claude/plans/qr-handoff-binding.md, 25-10-2026). Keep the verifier in memory only.

function base64url(bytes) {
  let binary = '';
  bytes.forEach((b) => { binary += String.fromCharCode(b); });
  return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

export async function makePkcePair() {
  const verifier = base64url(crypto.getRandomValues(new Uint8Array(32)));
  const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(verifier));

  return { verifier, challenge: base64url(new Uint8Array(digest)) };
}
